export enum WalletE {
  Metamask = 'Metamask',
  Coinbase = 'Coinbase',
}
